
import { useMemo } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { useSegmentation } from '../../../hooks/useSegmentation';
import { RESOURCES_QUERY } from '../../queries/RESOURCES_QUERY';
import { refineResources } from '../../refinement/refineResources';
import { useSanitizer } from '../../../components/common/learningItem/sanitizers';
import { useTagsQuery } from './useTagsQuery';

export function useResourceListQuery( { filter, ...options } ) {
    const { data: rawData, loading, error, refetch } = useQuery( RESOURCES_QUERY, {
        fetchPolicy: 'network-only',
        ...options,
    } );
    const { loading: tagLoading, getTags } = useTagsQuery();
    const { segmentData, loading: segmentLoading } = useSegmentation();
    const { sanitizeResources } = useSanitizer();

    return useMemo ( () => {
        let refinedData = refineResources( rawData?.resources || [] );
        if ( filter ) {refinedData = refinedData.filter( r => filter.includes( r.id ) );}
        refinedData = sanitizeResources( refinedData );
        refinedData = segmentData( refinedData );
        refinedData = refinedData.map( res => ( { ...res, tags: getTags( res.tagIds ) } ) );

        return {
            error: ( error ),
            loading: ( loading || segmentLoading ),
            data: refinedData,
            refetch,
        };
    }, [ error, loading, rawData, refetch, segmentLoading, tagLoading, sanitizeResources ] );
}
